import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-to-app',
    templateUrl: './to-app.component.html',
    styleUrls: ['./to-app.component.scss'],
    standalone: false
})
export class ToAppComponent implements OnInit {

  faEnvelope = faEnvelope;

  public linkGoogle = "https://play.google.com/store/apps/details?id=com.enthemo.enthemo";
  public linkApple = "https://apps.apple.com/app/enthemo/id6450899960";

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    if (!this.isBrowser())
      return;

    switch(this.getMobileOperatingSystem()) {
      case "iOS":
        window.location.href = this.linkApple;
        break;
      case "Android":
        window.location.href = this.linkGoogle;
        break;
    }
  }

  public getMobileOperatingSystem() {
    if (!this.isBrowser())
      return "unknown";

    var userAgent = navigator.userAgent;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "iOS";
    }

    return "unknown";
  }

  private isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
}
